import styled from 'styled-components';
import Dropdown from './Dropdown';
import { colorSchema } from 'utils/style';

export default styled(Dropdown)`
  position: absolute;
  right: 0;
  top: 100%;
  width: 100%;
  z-index: 1;

  .dropdown {
    -ms-overflow-style: none;
    background: ${colorSchema('white')};
    border-radius: 5px;
    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);
    height: auto;
    max-height: 400px;
    overflow-y: scroll;
  }
`;
